// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stepper_stepper-wrapper__\\+6pOg {
  display: flex;
  flex-direction: column;
}

.Stepper_horizontal-stepper-wrapper__KgkyP {
  width: 100%;
  flex-direction: row;
}
.Stepper_horizontal-stepper-wrapper__KgkyP .Stepper_stepper__2SG6d {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.Stepper_horizontal-stepper-wrapper__KgkyP .Stepper_stepper__2SG6d .Stepper_stepper-selector__PbKT- {
  width: 60vw;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.Stepper_vertical-stepper-wrapper__klJRB {
  height: 100%;
  display: flex;
  align-items: center;
}
.Stepper_vertical-stepper-wrapper__klJRB .Stepper_stepper__2SG6d {
  height: 80%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;
  justify-content: space-around;
}
.Stepper_vertical-stepper-wrapper__klJRB .Stepper_stepper__2SG6d .Stepper_stepper-selector__PbKT- {
  height: 80%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.Stepper_title__Cy-zx {
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
}

.Stepper_vertical-line__8FoSn {
  width: 2px;
  background-color: #ffffff;
  height: 62%;
  margin-left: 7px;
  margin-top: 8px;
  position: absolute;
}

.Stepper_horizontal-line__au6ir {
  height: 7px;
  width: 60vw;
  position: absolute;
  background-color: #f2f2f2;
  margin-top: 27px;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Stepper/Stepper.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,WAAA;EACA,mBAAA;AADF;AAEE;EACE,WAAA;EACA,aAAA;EACA,6BAAA;AAAJ;AACI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACN;;AAIA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AADF;AAEE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;AAAJ;AACI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AACN;;AAIA;EACE,cCnCM;EDoCN,eEzCS;EF0CT,gBEtCU;AFqCZ;;AAIA;EACE,UAAA;EACA,yBC1CM;ED2CN,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBCnDoB;EDoDpB,gBAAA;AADF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.stepper-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.horizontal-stepper-wrapper {\n  width: 100%;\n  flex-direction: row;\n  .stepper {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n    .stepper-selector {\n      width: 60vw;\n      display: flex;\n      justify-content: space-between;\n      flex-direction: row;\n    }\n  }\n}\n\n.vertical-stepper-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  .stepper {\n    height: 80%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin: auto;\n    justify-content: space-around;\n    .stepper-selector {\n      height: 80%;\n      display: flex;\n      justify-content: space-between;\n      flex-direction: column;\n    }\n  }\n}\n\n.title {\n  color: colors.$white;\n  font-size: typography.$header-s;\n  font-weight: typography.$semi-bold;\n}\n\n.vertical-line {\n  width: 2px;\n  background-color: colors.$white;\n  height: 62%;\n  margin-left: 7px;\n  margin-top: 8px;\n  position: absolute;\n}\n\n.horizontal-line {\n  height: 7px;\n  width: 60vw;\n  position: absolute;\n  background-color: colors.$color-background-02;\n  margin-top: 27px;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepper-wrapper": `Stepper_stepper-wrapper__+6pOg`,
	"horizontal-stepper-wrapper": `Stepper_horizontal-stepper-wrapper__KgkyP`,
	"stepper": `Stepper_stepper__2SG6d`,
	"stepper-selector": `Stepper_stepper-selector__PbKT-`,
	"vertical-stepper-wrapper": `Stepper_vertical-stepper-wrapper__klJRB`,
	"title": `Stepper_title__Cy-zx`,
	"vertical-line": `Stepper_vertical-line__8FoSn`,
	"horizontal-line": `Stepper_horizontal-line__au6ir`
};
export default ___CSS_LOADER_EXPORT___;
